import { makeStyles } from "@fluentui/react-components";

export const useHelpStyle = makeStyles({
    root: {
        paddingLeft: "20px",
        paddingRight: "20px"
    },
    versionContainer: {
        display: "flex",
        flexDirection: "row"
    },
    icon: {
        marginRight: "10px",
        marginTop: "5px"
    }
});
